import { faTrashCan, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

export default (props) => {
  const { proxy, pages, lang, functions } = useSelector((state) => state);
  const [current, setCurrent] = useState([]);
  const [rootData, setRootData] = useState([]);
  const [fileUploads, SetFileUploads] = useState([]);
  const [imageError, setImageError] = useState(false);
  const [newImages, setNewImages] = useState([]);
  const [removedImages, setRemovedImages] = useState([]);

  const {
    field,
    changeTrigger,
    defaultValue,
    isMultiple,
    col,
    refresh,
    isCustom,
  } = props;
  console.log(16, fileUploads);
  const {
    isExcelDocumentFormat,
    isPdfDocumentFormat,
    isDocDocumentFormat,
    isZipDocumentFormat,
  } = functions;

  useEffect(() => {
    SetFileUploads([]);
  }, [refresh]);

  const fieldChangeData = (e) => {
    const { value } = e.target;
    setCurrent(value);
    changeTrigger(field, value);
  };

  useEffect(() => {
    if (defaultValue && Array.isArray(defaultValue)) {
      setCurrent(defaultValue);
      setRootData(defaultValue || []);
    }
  }, [defaultValue]);

  const acceptTypes = field?.FILE_ACCEPT_TYPES?.map((type) => `.${type}`).join(
    ","
  );

  console.log(current);

  const handleAttachMedia = (e) => {
    console.log(e);
    if (
      !field.FILE_MULTIPLE &&
      current &&
      current.length > 0 &&
      fileUploads &&
      fileUploads.length > 0 &&
      !isCustom
    ) {
      return;
    }
    const newFiles = Array.from(e.target.files).filter((file) => {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (isCustom) {
        const validExtensions = [
          "pdf",
          "xls",
          "xlsx",
          "doc",
          "docx",
          "jpg",
          "jpeg",
          "png",
        ];

        const validMimeTypes = [
          "application/pdf",
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "image/jpeg",
          "image/png",
        ];

        return (
          validExtensions.includes(fileExtension) ||
          validMimeTypes.includes(file.type)
        );
      } else {
        if (file.type.startsWith("image/") || file.type.startsWith("video/")) {
          return true;
        } else if (file.type === "application/pdf" || fileExtension === "pdf") {
          return true;
        } else if (
          file.type.includes("excel") ||
          fileExtension === "xls" ||
          fileExtension === "xlsx"
        ) {
          return true;
        } else if (fileExtension === "zip") {
          return true;
        }
        // Thêm điều kiện cho file Word
        else if (
          file.type ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
          fileExtension === "docx" ||
          file.type === "application/msword" ||
          fileExtension === "doc"
        ) {
          return true;
        }
        return false;
      }
    });
    console.log(830, newFiles);

    if (newFiles.length < e.target.files.length) {
      if (isCustom) {
        Swal.fire({
          icon: "error",
          title: lang["error"] || "Lỗi",
          text: "File không đúng định dạng.\nVui lòng chọn file có định dạng: PDF, Word, Excel hoặc ảnh.",
          confirmButtonText: lang["ok"] || "OK",
          allowOutsideClick: false,
          customClass: {
            popup: "swal2-popup-custom",
          },
        });
      }

      // e.target.value = '';
      return;
    }
    const newMediaPromises = newFiles.map((file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();

        reader.onload = (readerEvent) => {
          // Xác định fileType dựa trên MIME type hoặc phần mở rộng của file
          let fileType;
          const fileExtension = file.name.split(".").pop().toLowerCase();
          // Thêm điều kiện cho file Word
          if (file.type.startsWith("video/")) {
            fileType = "video";
          } else if (file.type.startsWith("image/")) {
            fileType = "image";
          } else if (
            file.type ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ) {
            fileType = "word";
          } else if (file.type === "application/msword") {
            fileType = "word";
          } else if (fileExtension === "xls" || fileExtension === "xlsx") {
            fileType = "excel";
          } else if (fileExtension === "pdf") {
            fileType = "pdf";
          } else if (fileExtension === "zip") {
            fileType = "zip";
          } else {
            fileType = "unknown";
          }
          const mediaObject = {
            name: file.name,
            size: file.size,
            url: URL.createObjectURL(file),
            type: fileType,
            dataUrl: readerEvent.target.result, // Chuỗi base64
          };
          resolve(mediaObject);
        };

        if (file.type.startsWith("image/") || file.type.startsWith("video/")) {
          reader.readAsDataURL(file);
        } else {
          // Đọc file PDF và Excel dưới dạng base64
          reader.readAsDataURL(file);
        }
      });
    });

    Promise.all(newMediaPromises).then((newImg) => {
      SetFileUploads((prev) =>
        Array.isArray(prev) ? [...prev, ...newImg] : [...newImg]
      );
    });
    e.target.value = "";
  };

  async function convertImageToBase64(url) {
    return fetch(url, { mode: "no-cors" })
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );
  }

  async function processImagePaths(paths) {
    if (!Array.isArray(paths)) {
      // Trả về một mảng rỗng nếu paths không phải là một mảng
      return [];
    }
    const imagesData = [];
    for (const path of paths) {
      const base64FullString = await convertImageToBase64(path);
      console.log(base64FullString);
      // Cắt để lấy chỉ chuỗi base64
      const base64 = base64FullString.split("base64,").pop();
      if (typeof paths === "string") {
        const filename = path.split("/").pop();
        imagesData.push({
          filename,
          base64,
        });
      }
    }
    return imagesData;
  }

  useEffect(() => {
    const dataImg = fileUploads?.map((item) => ({
      filename: item.name,
      base64: item.dataUrl ? item.dataUrl.split("base64,").pop() : null,
    }));

    processImagePaths(current).then((imagesData) => {
      changeTrigger(
        field,
        dataImg.length || rootData.length
          ? {
              newImages: dataImg,
              currentImages:
                rootData?.filter((image) => current?.includes(image)) || [],
              removedImages:
                rootData?.filter((image) => !current?.includes(image)) || [],
            }
          : []
      );
    });
  }, [fileUploads, current, rootData]);

  const removeAttachMedia = (e, media) => {
    e.stopPropagation();
    e.preventDefault();
    const updatedMediaList = Array.isArray(current)
      ? current?.filter((item) => item !== media)
      : [];
    setCurrent(updatedMediaList);
  };

  const removeUploadFiles = (e, media) => {
    e.stopPropagation();
    e.preventDefault();
    const updatedMediaList = fileUploads?.filter((item) => item !== media);

    SetFileUploads(updatedMediaList);
  };

  const handleMediaRender = (media) => {
    return mediaIcons[media.type] ? mediaIcons[media.type](media) : null;
  };
  const mediaIcons = {
    image: (media) => (
      <img
        src={media.url}
        alt={`Selected ${media.name}`}
        className="selected-image-add"
        data-toggle="modal"
        data-target="#previewMedia"
        title={media.name}
      />
    ),
    video: (media) => (
      <div>
        <img
          src={media.cover}
          alt={`Cover for ${media.name}`}
          className="selected-image-add"
          data-toggle="modal"
          data-target="#previewMedia"
          title={media.name}
        />
        <div className="video-duration">Video</div>
      </div>
    ),
    pdf: (media) => (
      <img
        src="/images/icon/pdf.svg"
        alt={`Selected ${media.name}`}
        className="selected-image-add"
        title={media.name}
      />
    ),
    excel: (media) => (
      <img
        src="/images/icon/excel.svg"
        alt={`Selected ${media.name}`}
        className="selected-image-add"
        title={media.name}
      />
    ),
    word: (media) => (
      <img
        src="/images/icon/docs.svg"
        alt={`Selected ${media.name}`}
        className="selected-image-add"
        title={media.name}
      />
    ),
    zip: (media) => (
      <img
        src="/images/icon/zip.png"
        alt={`Selected ${media.name}`}
        className="selected-image-add"
        title={media.name}
      />
    ),
  };
  return (
    <div class="row justify-content-center ">
      <div class={col ? col : `col-md-8  mb-1`}>
        <div class="form-group">
          <label for="name">
            {field.field_name}
            {field.NULL && <span style={{ color: "red" }}> *</span>}
          </label>
          <div className="custom-file">
            <input
              type="file"
              id="customFile"
              className="custom-file-input"
              accept={acceptTypes}
              multiple={field.FILE_MULTIPLE ? true : isMultiple ?? false}
              onChange={handleAttachMedia}
            />
            <label className="custom-file-label" htmlFor="customFile">
              Choose file
            </label>
          </div>
        </div>

        <div
          className={
            fileUploads.length || current.length
              ? `selected-images-container-add`
              : ""
          }
          style={{
            height:
              isCustom && (current.length || fileUploads.length) && "25vh",
            overflow: isCustom && "auto",
            flexDirection: isCustom && "column",
            flexWrap: isCustom && "nowrap",
          }}
        >
          {Array.isArray(current) && current.length
            ? isCustom
              ? current?.map((media, index) => {
                  return (
                    <div
                      key={index}
                      className="selected-image-wrapper-add"
                      style={{
                        width: isCustom && "fit-content",
                      }}
                    >
                      <p>{media.name}</p>
                      {!isCustom && handleMediaRender(media)}
                      <button
                        type="button"
                        onClick={(e) => {
                          setCurrent((prev) =>
                            prev.filter((_, i) => i !== index)
                          );
                        }}
                        className="remove-image"
                        title={lang["delete image"]}
                      >
                        &times;
                      </button>
                    </div>
                  );
                })
              : current?.map((item, index) => {
                  const media = isCustom ? item.url : item;
                  return (
                    <div
                      key={index}
                      className="selected-image-wrapper-add"
                      style={{
                        width: isCustom && "fit-content",
                      }}
                    >
                      {functions.isExcelDocumentFormat(media) ? (
                        <img
                          src={"/images/icon/excel.svg"}
                          alt={`Selected ${index}`}
                          className="selected-image-add"
                          data-toggle="modal"
                          data-target="#previewMedia"
                          title={
                            media
                          } /*onClick={() => openModalPreview(media)}*/
                        />
                      ) : functions.isPdfDocumentFormat(media) ? (
                        <img
                          src={"/images/icon/pdf.svg"}
                          alt={`Selected ${index}`}
                          className="selected-image-add"
                          data-toggle="modal"
                          data-target="#previewMedia"
                          title={
                            media
                          } /*onClick={() => openModalPreview(media)}*/
                        />
                      ) : functions.isDocDocumentFormat(media) ? (
                        <img
                          src={"/images/icon/docs.svg"}
                          alt={`Selected ${index}`}
                          className="selected-image-add"
                          data-toggle="modal"
                          data-target="#previewMedia"
                          title={
                            media
                          } /*onClick={() => openModalPreview(media)}*/
                        />
                      ) : functions.isZipDocumentFormat(media) ? (
                        <img
                          src={"/images/icon/zip.svg"}
                          alt={`Selected ${index}`}
                          className="selected-image-add"
                          data-toggle="modal"
                          data-target="#previewMedia"
                          title={
                            media
                          } /*onClick={() => openModalPreview(media)}*/
                        />
                      ) : (
                        <img
                          src={proxy() + media}
                          className="selected-image-add"
                          title={
                            media
                          } /*onClick={() => openModalPreview(media)}*/
                        />
                      )}
                      <button
                        onClick={(e) => removeAttachMedia(e, media)}
                        className="remove-image"
                        title={lang["delete image"]}
                      >
                        &times;
                      </button>
                    </div>
                  );
                })
            : null}
          {fileUploads?.map((media, index) => {
            return (
              <div
                key={index}
                className="selected-image-wrapper-add"
                style={{
                  width: isCustom && "fit-content",
                }}
              >
                {isCustom && <p>{media.name}</p>}
                {!isCustom && handleMediaRender(media)}
                <button
                  onClick={(e) => removeUploadFiles(e, media)}
                  className="remove-image"
                  title={lang["delete image"]}
                >
                  &times;
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
